// import { Button, Card, Skeleton, DatePicker, Spin } from "antd";
// import React, { useEffect, useState } from "react";

import { useEffect, useRef, useState } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { Button, Card, Checkbox, DatePicker, Skeleton } from "antd";
import CustomDrawer from "../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import TreeSelectCustom from "../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { APIConstants } from "../../../../../Common/APIConstants";
import * as echarts from 'echarts';
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { generatedISOFormatDateString, groupDataByInterval, groupDataByIntervalAir, groupDataByIntervalElectrical } from "../../../../../Utils/DateConverstion";

// import ReactApexChart from "react-apexcharts";
// // import dayjs from "dayjs";
// import { TimePicker } from "antd";

// import {
//   filterDataByTimeRange,
//   generatedISOFormatDateString,
//   groupDataByInterval,
//   setUTCDate,
// } from "../../../../../Utils/DateConverstion";

// import  TreeSelectCustom from "../../../../Elements/TreeSelect/TreeSelectCustom";
// import CustomDrawer from "../../../../Elements/CustomDrawer";
// import CustomSelect from "../../../../Elements/CustomSelect";
// import ExportToExel from "../../../../Elements/Grid/Export";
// import TreeSelectCustomWithSelectAll from "../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
// import { useSelector } from "react-redux";
// import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
// import { APIConstants } from "../../../../../Common/APIConstants";

// const { RangePicker } = TimePicker;

// const AirComparativeReport = () => {
//   const { loading, makeRequest } = useStoreUpdaterWithAPI();
//   const [sectionId, setSectionId] = useState(null);
// const [converterGroupId, setConverterGroupId] = useState();
// const [report, setReport] = useState(null);
// const [selectedMeterIds, setSelectedMeterIds] = useState([]);
// const [selectedValues, setSelectedValues] = useState([]);
// const [fromDateObj, setFromDateObj] = useState(null);
// const [fromDateString, setFromDateString] = useState(null);
// const [toDateObj, setToDateObj] = useState(null);
// const [toDateString, setToDateString] = useState(null);
// const [skip, setSkip] = useState(true);
// const [open, setOpen] = useState(false);

// const [meters, setMeters] =useState([])
// const [excelReport, setExcelReport] = useState([])
// const [isLoading, setIsLoading] = useState(true);

// const [aggregationTime, setAggregationtime] = useState(null);

// const [aggeregationResData, setaggeregationResData] = useState([]);
// const [sectionError, setSectionError] = useState();
// const [converterError, setConverterError] = useState();
// const [meterError, setMeterError] = useState();
// const [paraError, setParaError] = useState();
// const [fromDateError, setFromDateError] = useState();
// const [toDateError, setToDateError] = useState();
// const [aggregationError, setAggregationError] = useState();
// const [flowSectionResData, setflowSectionResData] = useState([]);
// const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
// const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
// const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
// const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
// const [data, setData] = useState([]);

// const mode = useSelector((state) => state.darkMode);

// const { isdarkMode } = mode;


// const showDrawer = () => {
//   setOpen(true);
// };
// const onClose = () => {
//   setOpen(false);
// };


// const [chartData, setChartData] = useState({
//   series: [],
//   options: {
//     chart: {
//       id: "Comparative-report",
//       height: 350,
//       type: "line",
//       zoom: {
//         type: "x",
//         enabled: true,
//         // autoScaleYaxis: true,
//       },
//       toolbar: {
//         autoSelected: "zoom",
//       },
//     },
//     legend: {
//       show: true,
//       showForSingleSeries: true,
//       showForNullSeries: true,
//       showForZeroSeries: true,
//       position: 'bottom',
//       horizontalAlign: 'center', 
//       floating: false,
//       fontSize: '14px',
//       fontFamily: 'Helvetica, Arial',
//       fontWeight: 400,
//       formatter: undefined,
//       inverseOrder: false,
//       width: undefined,
//       height: undefined,
//       tooltipHoverFormatter: undefined,
//       customLegendItems: [],
//       offsetX: 0,
//       offsetY: 0,
//       labels: {
//           colors: undefined,
//           useSeriesColors: false
//       },
//       markers: {
//           width: 12,
//           height: 12,
//           strokeWidth: 0,
//           strokeColor: '#fff',
//           fillColors: undefined,
//           radius: 12,
//           customHTML: undefined,
//           onClick: undefined,
//           offsetX: 0,
//           offsetY: 0
//       },
//       itemMargin: {
//           horizontal: 5,
//           vertical: 10
//       },
//       onItemClick: {
//           toggleDataSeries: true
//       },
//       onItemHover: {
//           highlightDataSeries: false
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       curve: "smooth",
//     },
//     markers: {
//       size: 5,
//       strokeOpacity: 0.3,
//       hover: {
//         size: undefined,
//         sizeOffset: 3,
//       },
//     },
//     title: {
//       // display: true,
//       text: "Comparative Chart",
//       // color:  'red',

//       style: {
//  color: isdarkMode ? "#FFFFFF" : "#000000",
//             // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
//          fontSize: "18px", 
//          fontWeight: "bold" },
      
//     },
//     xaxis: {
//       categories: [],
//       labels: { 
//         style: { 
//           color: "red",
//         }
//       },
//       title: { 
//         text: "Date", 
//         style: {
//           color: isdarkMode ? "#FFFFFF" : "#000000",
//         }
//       }
//     },
//     yaxis: {
//       title: {
//         text: "Value",
//       },
//     },
//     // tooltip: {
//     //   y: [
//     //     {
//     //       title: {
//     //         formatter: function (val) {
//     //           return val + " (mins)";
//     //         },
//     //       },
//     //     },
//     //     {
//     //       title: {
//     //         formatter: function (val) {
//     //           return val + " per session";
//     //         },
//     //       },
//     //     },
//     //     {
//     //       title: {
//     //         formatter: function (val) {
//     //           return val + "Kg";
//     //         },
//     //       },
//     //     },
//     //   ],
//     // },
//     tooltip: {
//       x: {
//         show: true,
//         format: "dd-MMM",
//         formatter: undefined,
//       },
//       y: {
//         title: {
//           formatter: (
//             seriesName,
//             { series, seriesIndex, dataPointIndex, w }
//           ) => {
//             const isFlowRate = seriesName.includes("flowRate");
//             const kgLabel = isFlowRate ? " Kg/hr" : "Kg";

//             // Assuming opts.value contains the actual y-axis value
//             return seriesName + kgLabel;
//           },
//         },
//       },
//     },
//   },
// });
// useEffect(() => {
//   // After 1 second, set skipValue to false 
//   const timeoutId = setTimeout(() => { 
//     setSkip(false); 
//   }, 3000);

//   // Clear the timeout if the component unmounts or skipValue is set to false
//   return () => clearTimeout(timeoutId);
// }, []);

// useEffect(() => {
//   makeRequest({
//     type: APIConstants.GET,
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
//   }).then((res) => {
//     console.log(res)
//     setflowSectionResData(res);
//   });


//   makeRequest({
//     type: APIConstants.GET,
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
//   }).then((res) => {
//     console.log(res)
//     setgetFlowConverterResData(res);
//   });


//   makeRequest({
//     type: APIConstants.GET,
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
//   }).then((res) => {
//     console.log(res)
//     setflowGroupDetailsResData(res);
//   });


//   makeRequest({
//     type: APIConstants.GET,
  
//     url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`
//   }).then((res) => {
//     console.log(res)
//     setaggeregationResData(res);
//   });

// }, [])



// useEffect(() => {

//   if(converterGroupId) {
//     makeRequest({
//       type: APIConstants.GET,
//       // GetFlowSteamGropeMeterDetails?GroupID=81
//       url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}`
//     }).then((res) => {
//       console.log(res)
//       setnsGetFlowConverterResData(res);
//     });

//   }


//   makeRequest({
//     type: APIConstants.GET,
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
//   }).then((res) => {
//     console.log(res)
//     setgetFlowSteamGroupMeterResData(res);
//   });
// }, [converterGroupId])



// const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
// const getFlowConverterList =
//   (getFlowConverterResData && getFlowConverterResData) || [];
// const flowGroupDetailsList =
//   (flowGroupDetailsResData && flowGroupDetailsResData) || [];
//   const nsGetFlowConverterList =
//   (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
// const getFlowSteamGroupMeterList =
//   (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
//   const aggeregationList = (aggeregationResData && aggeregationResData) || [];

// // console.log(nsGetFlowConverterList)
// const handleChangeAggregation = (value) => {
// setAggregationtime(value);
// if (value) {
//   setAggregationError("");
// }
// };


// const handleChangeSection = (changedValues) => {
//   setSectionId(changedValues);
//   setSelectedMeterIds();
//   if (changedValues) {
//     setSectionError("");
//   }
// };

// const handleChangeConverterGroup = (changedValues) => {
//   setConverterGroupId(changedValues);
//   setSelectedMeterIds();
//   if (changedValues) {
//     setConverterError("");
//   }
// };

// const handleMeterChange = (selectedValues) => {
//   setSelectedMeterIds(selectedValues);
//   if (selectedValues) {
//     setMeterError("");
//   }
// };

// const onChangeFromDate = (date, dateString) => {
//   setFromDateString(dateString);
//   setFromDateObj(date);
//   if (dateString) {
//     setFromDateError("");
//   }
// };

// const onChangeToDate = (date, dateString) => {
//   setToDateString(dateString);
//   setToDateObj(date);
//   if (dateString) {
//     setToDateError("");
//   }
// };


// const getResponse = (inputData) => {
//   console.log(inputData)

//   makeRequest({
//     type: APIConstants.GET, 
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     // url: `${APIConstants.GET_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
//     // url: `${APIConstants.GET_STEAM_DASHBOARD_HISTORICAL_DETAILS}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
    
//     url: `http://20.244.40.160:81/api/Air/AirComparitive?SectionID=1&ConverterorGroupID=21&MeterIds=75%2C76%2C77&FromDate=2023-10-01%2001%3A16%3A00&Todate=2023-10-01%2002%3A16%3A00`

//   }).then((res) => {
//     // console.log(url)
 
//     console.log(res)
//     setData(res);
//   });
// }


// const validateInput = (value, label) => {
//   const error = !value ? `Please Select ${label}` : "";
//   return error;
// };


// const validateToDateInput = (
//   toDateValue,
//   fromDateValue,
//   aggregationPeriod,
//   label
// ) => {
//   switch (aggregationPeriod) {
//     case 1: {
//       // Validate if the time difference is a multiple of 15 minutes
//       const timeDifferenceInMilliseconds =
//         new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
//       const timeDifferenceInMinutes =
//         timeDifferenceInMilliseconds / (1000 * 60);

//       const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
//       const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

//       let error = "";
//       if (!isMultipleOf15Minutes) {
//         error = `Time difference must be a multiple of 15 minutes for ${label}`;
//       } else if (!isAtLeast1Hour) {
//         error = `Minimum time difference must be 1 hour for ${label}`;
//       }

//       return error;
//     }
//     case 2: {
//       // Validate if the time difference is a multiple of 60 minutes
//       const timeDifferenceInMilliseconds =
//         new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
//       const timeDifferenceInMinutes =
//         timeDifferenceInMilliseconds / (1000 * 60);

//       const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
//       const isAtLeast1Hour = timeDifferenceInMinutes >= 8 * 60;

//       let error = "";
//       if (!isMultipleOf15Minutes) {
//         error = `Time difference must be a multiple of 60 minutes for ${label}`;
//       } else if (!isAtLeast1Hour) {
//         error = `Minimum time difference must be 8 hours for ${label}`;
//       }

//       return error;
//     }
//     case 3: {
//       // Validate if the time difference is a multiple of 60 minutes
//       const timeDifferenceInMilliseconds =
//         new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
//       const timeDifferenceInMinutes =
//         timeDifferenceInMilliseconds / (1000 * 60);

//       const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
//       const isAtLeast1Hour = timeDifferenceInMinutes >= 7 * 24 * 60;

//       let error = "";
//       if (!isMultipleOf15Minutes) {
//         error = `Time difference must be a multiple of 24 hours for ${label}`;
//       } else if (!isAtLeast1Hour) {
//         error = `Minimum time difference must be 1 week for ${label}`;
//       }

//       return error;
//     }
//     case 4: {
//       // Validate if the time difference is a multiple of 60 minutes
//       const fromDate = new Date(fromDateValue);
//       const toDate = new Date(toDateValue);

//       const monthsDifference =
//         (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
//         (toDate.getUTCMonth() - fromDate.getUTCMonth())
//         // +toDate.getUTCDate()-fromDate.getUTCDate());
        
        
//         //   // Calculate the year and month difference
       
        

//       const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
//       const isAtLeast6Months = monthsDifference >= 2; 
     

//       let error = "";
//       if (!isMultipleOf15Minutes) {
//         error = `Time difference must be a multiple of 1 month for ${label}`;
//       } else if (!isAtLeast6Months) {
//         error = `Minimum time difference must be 2 month for ${label}`;
//       }

//       return error;
//     }
//     case 5: {
//       // Validate if the time difference is a multiple of 60 minutes
//       const timeDifferenceInMilliseconds =
//         new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
//       const timeDifferenceInMinutes =
//         timeDifferenceInMilliseconds / (1000 * 60);

//       const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 8) === 0;
//       const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

//       let error = "";
//       if (!isMultipleOf15Minutes) {
//         error = `Time difference must be a multiple of 8 hours for ${label}`;
//       } else if (!isAtLeast1Hour) {
//         error = `Minimum time difference must be 1 day for ${label}`;
//       }

//       return error;
//     }
//     default: {
//       // Handle invalid aggregation period
//       return `Invalid aggregation period: ${aggregationPeriod}`;
//     }
//   }
// };

// //   const handleSubmit = async () => {
// //     const sectionError = validateInput(sectionId, "Section");
// //     const converterError = validateInput(converterGroupId, "Converter");
// //     const meterError = validateInput(selectedMeterIds?.length, "Meter");
// //     const paraError = validateInput(selectedValues, "Parameter");
// //     const fromDateError = validateInput(fromDateString, "From Date");
// //     const toDateError = validateToDateInput(
// //       toDateString,
// //       fromDateString,
// //       aggregationTime,
// //       "From Date"
// //     );
// //     const aggregationError = validateInput(aggregationTime, "Aggregation");

// //     setSectionError(sectionError);
// //     setConverterError(converterError);
// //     setMeterError(meterError);
// //     setParaError(paraError);
// //     setFromDateError(fromDateError);
// //     setToDateError(toDateError);
// //     setAggregationError(aggregationError);

// //     if ( 
// //       !sectionError &&
// //       !converterError &&
// //       !meterError &&
// //       !paraError &&
// //       !fromDateError &&
// //       !toDateError &&
// //       !aggregationError
// //     ) {
// //       onClose();

// //       const ids = selectedMeterIds?.map((id) => id).join(",");

// //       const fromDate = new Date(fromDateString); 
// //       const toDate = new Date(toDateString);

// //       const fromHours = fromDate.getUTCHours();
// //       const fromMinutes = fromDate.getUTCMinutes();
// //       const fromSeconds = fromDate.getUTCSeconds();

// //       const toHours = toDate.getUTCHours();
// //       const toMinutes = toDate.getUTCMinutes();
// //       const toSeconds = toDate.getUTCSeconds();

// //       // Set the UTC hours, minutes, and seconds
// //       fromDate.setUTCHours(fromHours);
// //       fromDate.setUTCMinutes(fromMinutes);
// //       fromDate.setUTCSeconds(fromSeconds);

// //       toDate.setUTCHours(toHours);
// //       toDate.setUTCMinutes(toMinutes);
// //       toDate.setUTCSeconds(toSeconds);

// //       const formattedFromDate = generatedISOFormatDateString(fromDate);
// //       const formattedToDate = generatedISOFormatDateString(toDate);

// //       try {
// //         const inputData = {
// //           SectionID: Number(sectionId) || 1,
// //           ConverterorGroupID: Number(converterGroupId) || 40,
// //           MeterIds: ids || ["1"],
// //           FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
// //           ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
// //         };

// //         const queryString = objectToQueryString(inputData);
// //         const res = await meterDataDetailsForHistorical(queryString); 
// //         const data = [...res?.data].reverse();
// //         setReport(data);
// //         const aggregationName = aggeregationResData.find(
// //           (aggregation) => aggregation.aggregationPeriodID === aggregationTime
// //         ).aggregationPeriodName;

// //         const period =
// //           aggregationName === "15Mins"
// //             ? "min"
// //             : aggregationName === "60Min Report" 
// //             ? "min" 
// //             : aggregationName === "24Hours Report"
// //             ? "day"
// //             : aggregationName === "Monthly Report"
// //             ? "month"
// //             : "min";

// //         const interval =
// //           aggregationName === "15Mins"
// //             ? 15
// //             : aggregationName === "60Min Report"
// //             ? 60
// //             : aggregationName === "24Hours Report"
// //             ? 1
// //             : aggregationName === "Monthly Report"
// //             ? 1
// //             : 480; 

// //         const seriesData = groupDataByInterval( 
// //           data,
// //           interval,
// //           period,
// //           fromDate
// //         ); 

// //         console.log('seriesData')
// //         console.log(seriesData.metername) 
// //         setMeters(seriesData.metername)
      


// //         const result = [];

// //   // Create a map to hold date-wise entries 
// //        const dateMap = {};



// //  seriesData.chartArray.forEach(({ name, data, date }) => { 
// //   data.forEach((value, index) => {
// //     const dateTime = date[index];   
  
// //     if (!dateMap[dateTime]) {
// //       dateMap[dateTime] = { date: dateTime }; 
// //     }
  
// //     dateMap[dateTime][name] = value;
// //   });
// //  });

// //     // Convert map to array
// //     for (const dateTime in dateMap) {
// //   result.push(dateMap[dateTime]);
// //      } 

// //     console.log(result);
// //      setExcelReport(result)

// //         const input = seriesData?.chartArray; 

// //         const inputArr = input;
// //         const dateArray = seriesData?.firstRecordCreatedONArray;
// //         console.log(dateArray);

// //       //   function convertTo24Hour(dateString) {
// //       //     // Split the date and time
// //       //     const [datePart, timePart] = dateString.split(', ');
    
// //       //     // Split the date part into day, month, and year
// //       //     const [day, month, year] = datePart.split('/').map(Number);
    
// //       //     // Split the time part into time and period (AM/PM)
// //       //     let [time, period] = timePart.split(' ');
// //       //     let [hours, minutes, seconds] = time.split(':').map(Number);
    
// //       //     // Convert hours based on AM/PM period
// //       //     if (period.toLowerCase() === 'pm' && hours !== 12) {
// //       //         hours += 12;
// //       //     } else if (period.toLowerCase() === 'am' && hours === 12) {
// //       //         hours = 0;
// //       //     }
    
// //       //     // Format the date and time to a 24-hour format string
// //       //     const formattedDate = new Date(year, month - 1, day, hours, minutes, seconds)
// //       //         .toLocaleString('en-GB', { hour12: false })
// //       //         .replace(',', '');
    
// //       //     return formattedDate;
// //       // }
    
// //       // const input = "20/11/2023, 7:15:00 am";    
// //       // const output = convertTo24Hour(dateArray[1]); 
// //       // console.log(output);  // Output: "20/11/2023 07:15:00"
     


    

// //     //   function convertTo24Hour(dateString) {
// //     //     // Split the date and time
// //     //     const [datePart, timePart] = dateString.split(', ');
  
// //     //     // Split the date part into day, month, and year
// //     //     const [day, month, year] = datePart.split('/').map(Number);
  
// //     //     // Split the time part into time and period (AM/PM)
// //     //     let [time, period] = timePart.split(' ');
// //     //     let [hours, minutes, seconds] = time.split(':').map(Number);
  
// //     //     // Convert hours based on AM/PM period
// //     //     if (period.toLowerCase() === 'pm' && hours !== 12) {
// //     //         hours += 12;
// //     //     } else if (period.toLowerCase() === 'am' && hours === 12) {
// //     //         hours = 0;
// //     //     }
  
// //     //     // Create a Date object
// //     //     const date = new Date(year, month - 1, day, hours, minutes, seconds);
  
// //     //     // Get the month name
// //     //     const monthName = date.toLocaleString('en-GB', { month: 'short' });
  
// //     //     // Format the date and time to a 24-hour format string with month name
// //     //     const formattedDate = `${day.toString().padStart(2, '0')} ${monthName} ${year}, ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  
// //     //     return formattedDate;
// //     // }
  
// //     // // Example usage: 
// //     // const dateString = "25/12/2023, 10:15:30 PM";
// //     // console.log(convertTo24Hour(dateString)); // Output: "25 December 2023, 22:15:30"

// //     function convertToTimestamp(dateString) {
// //       // Split the date and time
// //       const [datePart, timePart] = dateString.split(', ');

// //       // Split the date part into day, month, and year
// //       const [day, month, year] = datePart.split('/').map(Number);

// //       // Split the time part into time and period (AM/PM)
// //       let [time, period] = timePart.split(' ');
// //       let [hours, minutes, seconds] = time.split(':').map(Number);

// //       // Convert hours based on AM/PM period
// //       if (period.toLowerCase() === 'pm' && hours !== 12) {
// //           hours += 12;
// //       } else if (period.toLowerCase() === 'am' && hours === 12) {
// //           hours = 0;
// //       }

// //       // Create a Date object
// //       const date = new Date(year, month - 1, day, hours, minutes, seconds);

// //       // Return the timestamp
// //       return date.getTime();
// //   }
  
// //         // const correctDate = dateArray.map(convertToTimestamp);  
// //         // const correctDate = dateArray.map(date=>{     
// //         //   //  date = convertTo24Hour(date) 
// //         //   console.log(date)
// //         // })  

// //       //   const updatedData = inputArr.map(item => ({
// //       //     ...item,
// //       //     date: item.date.map(convertToTimestamp) 
// //       // }));
// //       // console.log(updatedData)
 
// //       //   console.log(inputArr);
// //       //   console.log(correctDate); 
// //         // update in columnData  
// //         setChartData((prevChartData) => ({ 
// //           series: inputArr || [], 
// //           options: {  
// //             ...prevChartData.options, 
// //             xaxis: {  
// //               ...prevChartData.options.xaxis,
// //               categories: dateArray || [''],
// //             },  
// //           },
// //         }));
// //       } catch (err) {
// //         console.log(err);
// //       }
// //     }
// //   };


// const handleSubmit = async () => {
// const sectionError = validateInput(sectionId, "Section");
// const converterError = validateInput(converterGroupId, "Converter");
// const meterError = validateInput(selectedMeterIds?.length, "Meter");
// const paraError = validateInput(selectedValues, "Parameter");
// const fromDateError = validateInput(fromDateString, "From Date");
// const toDateError = validateToDateInput(
//   toDateString,
//   fromDateString,
//   aggregationTime,
//   "From Date"
// );
// const aggregationError = validateInput(aggregationTime, "Aggregation");

// setSectionError(sectionError);
// setConverterError(converterError);
// setMeterError(meterError);
// // setParaError(paraError);
// setFromDateError(fromDateError);
// setToDateError(toDateError);
// setAggregationError(aggregationError);

// if (
//   !sectionError &&
//   !converterError &&
//   !meterError &&
//   !paraError &&
//   !fromDateError &&
//   !toDateError &&
//   !aggregationError
// ) {
//   onClose();

//   const ids = selectedMeterIds?.map((id) => id).join(",");

//   const fromDate = new Date(fromDateString);
//   const toDate = new Date(toDateString);

//   const fromHours = fromDate.getUTCHours();
//   const fromMinutes = fromDate.getUTCMinutes();
//   const fromSeconds = fromDate.getUTCSeconds();

//   const toHours = toDate.getUTCHours();
//   const toMinutes = toDate.getUTCMinutes();
//   const toSeconds = toDate.getUTCSeconds();

//   // Set the UTC hours, minutes, and seconds
//   fromDate.setUTCHours(fromHours);
//   fromDate.setUTCMinutes(fromMinutes);
//   fromDate.setUTCSeconds(fromSeconds);

//   toDate.setUTCHours(toHours);
//   toDate.setUTCMinutes(toMinutes);
//   toDate.setUTCSeconds(toSeconds);

//   const formattedFromDate = generatedISOFormatDateString(fromDate);
//   const formattedToDate = generatedISOFormatDateString(toDate);

//   try {
//     const inputData = {
//       SectionID: Number(sectionId) || 1,
//       ConverterorGroupID: Number(converterGroupId) || 40,
//       MeterIds: ids || ["1"],
//       FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
//       ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
//     };

//     setIsLoading(true); 
//     getResponse(inputData)



//     console.log('first data')
//     console.log(data)

//     const aggregationName = aggeregationResData.find(
//       (aggregation) => aggregation.aggregationPeriodID === aggregationTime
//     ).aggregationPeriodName;

//     const period =
//       aggregationName === "15Mins"
//         ? "min"
//         : aggregationName === "60Min Report"
//           ? "min"
//           : aggregationName === "24Hours Report"
//             ? "day"
//             : aggregationName === "Monthly Report"
//               ? "month"
//               : "min";

//     const interval =
//       aggregationName === "15Mins"
//         ? 15
//         : aggregationName === "60Min Report"
//           ? 60
//           : aggregationName === "24Hours Report"
//             ? 1
//             : aggregationName === "Monthly Report"
//               ? 1
//               : 480;

//     const seriesData = groupDataByInterval(
//       data,
//       interval,
//       period,
//       fromDate
//     );

//     const input = seriesData?.chartArray;

//     const inputArr = input;
//     const dateArray = seriesData?.firstRecordCreatedONArray;
//     console.log(dateArray)
//     console.log(inputArr)

//     // update in columnData
//     setChartData((prevChartData) => ({
//       series: inputArr || [],
//       options: {
//         ...prevChartData.options,
//         xaxis: {
//           ...prevChartData.options.xaxis,
//           categories: dateArray || [1],
//         },
//       },
//     }));
//   } catch (err) {
//     console.log(err);
//   }finally {
//     setIsLoading(false); 
//   }
// }
// };

// const parameters = [
//   { id: 1, name: "flowRate" },
//   { id: 2, name: "cumulative" },
// ];
// const handleTreeChange = (values) => {
//   setSelectedValues(values);
//   if (values) {
//     setParaError("");
//   }
// };

// return (
//   <div>
   
//    <div id="chart" className={` relative p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
//     {isLoading && (
//       <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-50 dark:bg-opacity-50 z-10">
//         <Spin active paragraph={{ rows: 6 }} />
//       </div>
//     )}


//     <Card
//       className={`p-4 rounded-md dark  ${isdarkMode ? "darkmode" : "whitemode"} 
// w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
//     >


//       <ReactApexChart
//         options={chartData.options}
//         series={chartData.series}
//         type="bar"
//         height={600}
//         className="w-full"

//       />


//     </Card>
//     </div>
//     <CustomDrawer
//       title="Close"
//       showDrawer={showDrawer}
//       open={open}
//       onClose={onClose}
//     >
//       <div className="flex flex-col space-y-2">
//         <CustomSelect
//           label="Section:"
//           options={getFlowSectionList}
//           onSelect={handleChangeSection}
//           valueKey="sectionID"
//           nameKey="sectionName"
//         />
//         <small className="text-red-500 font-bold ml-[150px]">
//           {/* {sectionError} */}
//         </small>
//         <CustomSelect
//           label="Converter / Group:"
//           options={
//             sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
//           }
//           onSelect={handleChangeConverterGroup}
//           valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
//           nameKey={sectionId === 1 ? "sitename" : "groupName"}
//         />
//         <small className="text-red-500 font-bold ml-[150px]">
//           {/* {converterError} */}
//         </small>
//         <TreeSelectCustomWithSelectAll
//           label="Meters:"
//           data={
//             sectionId === 1
//               ? nsGetFlowConverterList
//               : getFlowSteamGroupMeterList
//           }
//           idKey={sectionId === 1 ? "meterid" : "MeterID"}
//           valueKey={sectionId === 1 ? "meterid" : "meterID"}
//           nameKey={sectionId === 1 ? "metername" : "meterName"}
//           selectedValues={selectedMeterIds}
//           setSelectedValues={setSelectedMeterIds}
//           onSelect={handleMeterChange}
//         />
//         <small className="text-red-500 font-bold ml-[150px]">
//           {/* {meterError} */}
//         </small>
//         <TreeSelectCustom 
//           label="Parameters:"
//           data={parameters}
//           idKey="id"
//           nameKey="name"
//           valueKey="name"
//           selectedValues={selectedValues}
//           onSelect={handleTreeChange}
//         />
//         <small className="text-red-500 font-bold ml-[150px]">
//           {/* {paraError} */}
//         </small>
//         <CustomSelect
//           label="Aggregation period:"
//           options={aggeregationList}
//           onSelect={handleChangeAggregation}
//           valueKey="aggregationPeriodID"
//           nameKey="aggregationPeriodName"
//         />
//         <small className="text-red-500 font-bold ml-[150px]">
//           {aggregationError}
//         </small>
       
//         <div className="mt-2 flex">
//           <label className="pr-3 w-32 text-left">From Date:</label>
//           <DatePicker
//             value={fromDateObj}
//             onChange={onChangeFromDate}
//             className="w-80"
//             showTime={{ format: "HH:mm:ss" }}
//             format="YYYY-MM-DD HH:mm:ss"
//           />
//         </div>
//         <small className="text-red-500 font-bold ml-[150px]">
//           {/* {fromDateError} */}
//         </small>
//         <div className="mt-2 flex">
//           <label className="pr-3 w-32 text-left">To Date:</label>
//           <DatePicker
//             value={toDateObj}
//             onChange={onChangeToDate}
//             className="w-80"
//             showTime={{ format: "HH:mm:ss" }}
//             format="YYYY-MM-DD HH:mm:ss"
//           />
//         </div>
//         <small className="text-red-500 font-bold ml-[150px]">
//           {toDateError}
//         </small>
//       </div>
//       <div className="flex justify-center mt-4">
//         <Button
//           className="blue-btn"
//           onClick={() => {
//             handleSubmit();
//           }}
//         >
//           Search
//         </Button>
//       </div>
//     </CustomDrawer>
//   </div>
// );
// }

// export default AirComparativeReport





 
const AirComparativeReport = () => { 
const chartRef = useRef(null); 
const {loading,  makeRequest } = useStoreUpdaterWithAPI();
const [sectionId, setSectionId] = useState(null);
const [converterGroupId, setConverterGroupId] = useState();
const [selectedMeterIds, setSelectedMeterIds] = useState([]);
const [selectedValues, setSelectedValues] = useState([]);
const [fromDateObj, setFromDateObj] = useState(null);
const [fromDateString, setFromDateString] = useState(null);
const [toDateObj, setToDateObj] = useState(null);
const [toDateString, setToDateString] = useState(null);
const [skip, setSkip] = useState(true);
const [open, setOpen] = useState(false);
const [isLoading, setIsLoading] = useState(true);

const [aggregationTime, setAggregationtime] = useState(null);

const [aggeregationResData, setaggeregationResData] = useState([]);
const [sectionError, setSectionError] = useState();
const [converterError, setConverterError] = useState();
const [meterError, setMeterError] = useState();
const [paraError, setParaError] = useState();
const [fromDateError, setFromDateError] = useState();
const [toDateError, setToDateError] = useState();
const [aggregationError, setAggregationError] = useState();
const [flowSectionResData, setflowSectionResData] = useState([]);
const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
const [data, setData] = useState([]);
// const [parameter,setParameter]=useState([]);
const [data1,setData1]= useState([]);
const [data2,setData2]= useState([]);
const [loadings, setLoadings] = useState(true);
const [parameterLenght, setParameterLenght] = useState('')
const [to,setTo]=useState(null);
const [from,setFrom]=useState(null);

const [checkedValue, setCheckedValue] = useState(null);
const [time,setTime]= useState(false);
const [shift,setShift]=useState(null);

const simulateLoading = (setLoadings) => {
  setLoadings(true);
  setTimeout(() => {
    setLoadings(false);
  }, 2000); // 2 seconds
};
useEffect(()=>{
  simulateLoading(setLoadings);
},[])

const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;


const showDrawer = () => {
  setOpen(true);
};
const onClose = () => {
  setOpen(false);
};



useEffect(() => {
  // After 1 second, set skipValue to false
  const timeoutId = setTimeout(() => { 
    setSkip(false);
  }, 3000);

  // Clear the timeout if the component unmounts or skipValue is set to false
  return () => clearTimeout(timeoutId);
}, []);

useEffect(() => {
  makeRequest({
    type: APIConstants.GET,
    url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
  }).then((res) => {
    console.log(res)
    setflowSectionResData(res);
  });


  makeRequest({
    type: APIConstants.GET,
    url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
  }).then((res) => {
    console.log(res)
    setgetFlowConverterResData(res);
  });


  makeRequest({
    type: APIConstants.POST,
    url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
  }).then((res) => {
    console.log(res)
    setflowGroupDetailsResData(res);
  });


  makeRequest({
    type: APIConstants.GET,
  
    url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`
  }).then((res) => {
    console.log(res)
    setaggeregationResData(res);
  });


  // makeRequest({  
  //   type: APIConstants.GET, 
  //   url: `${APIConstants.ELECTRICAL_HISTORICAL_PARAMETERS_LIST}`
  // }).then((res) => {
  //   console.log(res)
  //   setParameter(res);
  // });

}, [])



useEffect(() => {

  if(converterGroupId) {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}`
    }).then((res) => {
      console.log(res)
      setnsGetFlowConverterResData(res);
    });
  }


  makeRequest({
    type: APIConstants.POST,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
    // url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
  }).then((res) => {
    console.log(res)
    setgetFlowSteamGroupMeterResData(res);
  });
}, [converterGroupId])

const parameter = [
  { parameterid: 1, parametername: "flowRate" },
  { parameterid: 2, parametername: "cumulative" },
];

const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
const getFlowConverterList =
  (getFlowConverterResData && getFlowConverterResData) || [];
const flowGroupDetailsList =
  (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
  (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
const getFlowSteamGroupMeterList =
  (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
  const aggeregationList = (aggeregationResData && aggeregationResData) || [];

const handleChangeAggregation = (value) => {
  console.log(value)
setAggregationtime(value);
setToDateError(null)
setFromDateError(null)
if (value) {
  setAggregationError("");
}
};


const handleChangeSection = (changedValues) => {
  setSectionId(changedValues);
  setSelectedMeterIds();
  if (changedValues) {
    setSectionError("");
  }
};

const handleChangeConverterGroup = (changedValues) => {
  setConverterGroupId(changedValues);
  console.log(changedValues)
  setSelectedMeterIds();
  if (changedValues) {
    setConverterError("");
  }
};

const handleMeterChange = (selectedValues) => {
  setSelectedMeterIds(selectedValues);
  if (selectedValues) {
    setMeterError("");
  }
};

const onChangeFromDate = (date, dateString) => {
  console.log(dateString)
  setFromDateString(dateString);
  setFromDateObj(date);
  if (dateString) {
    setFromDateError("");
  }
};

const onChangeToDate = (date, dateString) => {
  setToDateString(dateString);
  setToDateObj(date);
  if (dateString) {
    setToDateError("");
  }
};


const getResponse = (inputData) => {
  console.log(inputData)
   

  makeRequest({
    type: APIConstants.GET,
    // url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
       // GetFlowSteamGropeMeterDetails?GroupID=81
    // url: `${APIConstants.GET_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
    url: `${APIConstants.GET_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
    
    // url: `http://20.244.40.160:81/api/Air/AirComparitive?SectionID=1&ConverterorGroupID=21&MeterIds=75%2C76%2C77&FromDate=2023-10-01%2001%3A16%3A00&Todate=2023-10-01%2002%3A16%3A00`
  }).then((res) => { 
    console.log(res)
    if (res&&res.length>0) {   
      setData(res);
      timePeriod(res) 

    }
  });
}

const timePeriod = (data=>{

  const fromDate = new Date(fromDateString);
  const toDate = new Date(toDateString);

  const fromHours = fromDate.getUTCHours();
  const fromMinutes = fromDate.getUTCMinutes();
  const fromSeconds = fromDate.getUTCSeconds();

  const toHours = toDate.getUTCHours();
  const toMinutes = toDate.getUTCMinutes();
  const toSeconds = toDate.getUTCSeconds();

  // Set the UTC hours, minutes, and seconds
  fromDate.setUTCHours(fromHours);
  fromDate.setUTCMinutes(fromMinutes);
  fromDate.setUTCSeconds(fromSeconds);

  toDate.setUTCHours(toHours);
  toDate.setUTCMinutes(toMinutes); 
  toDate.setUTCSeconds(toSeconds);

  const formattedFromDate = generatedISOFormatDateString(fromDate);
  const formattedToDate = generatedISOFormatDateString(toDate);
  
  const aggregationName = aggeregationResData.find(
    (aggregation) => aggregation.aggregationPeriodID === aggregationTime
  ).aggregationPeriodName;

  const period =
    aggregationName === "15Mins"
      ? "min"
      : aggregationName === "60Min Report"
        ? "min"
        : aggregationName === "24Hours Report"
          ? "day"
          : aggregationName === "Monthly Report"
            ? "month"
            : "min";

  const interval =
    aggregationName === "15Mins"
      ? 15
      : aggregationName === "60Min Report"
        ? 60
        : aggregationName === "24Hours Report"
          ? 1
          : aggregationName === "Monthly Report"
            ? 1
            : 480;

    console.log(data)
    console.log(interval)
    console.log(period)
    console.log(fromDate)
    console.log(toDate)
  const seriesData = groupDataByIntervalAir(
    data,
    interval,
    period,
    fromDate,
    toDate,
    selectedValues
  );
  console.log(seriesData)

  const input = seriesData?.chartArray;
  console.log('first')
  console.log(input)

  const inputArr = input;
  const dateArray = seriesData?.firstRecordCreatedONArray;
  console.log(dateArray)
  console.log(inputArr)
  const series = inputArr.map((key,index) => ({
    name: key.name,
    type: 'bar',
    emphasis: {
      focus: 'series' 
    },
    data: key.data,
    date:dateArray
}));
console.log(series)
  setData1(dateArray)
  setData2(series) 
})

const validateInput = (value, label) => {
  const error = !value ? `Please Select ${label}` : "";
  return error;
};

const validateToDateInput = (
  toDateValue,
  fromDateValue,
  aggregationPeriod,
  label
) => {
  switch (aggregationPeriod) {
    case 1: {
      // Validate if the time difference is a multiple of 15 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 15 minutes for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 hour for ${label}`;
      }

      return error;
    }
    case 2: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 8 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 60 minutes for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 8 hours for ${label}`;
      }

      return error;
    }
    case 3: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 7 * 24 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 24 hours for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 week for ${label}`;
      }

      return error;
    }
    case 4: {
      // Validate if the time difference is a multiple of 60 minutes
      const fromDate = new Date(fromDateValue);
      const toDate = new Date(toDateValue);

      const monthsDifference =
        (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
        (toDate.getUTCMonth() - fromDate.getUTCMonth())        
        
          // Calculate the year and month difference
       
      
      const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
      const isAtLeast6Months = monthsDifference >= 2; 
     

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 1 month for ${label}`;
      } else if (!isAtLeast6Months) {
        error = `Minimum time difference must be 2 month for ${label}`;
      }

      return error;
    }
    case 5: {
      // Validate if the time difference is a multiple of 60 minutes
      const timeDifferenceInMilliseconds =
        new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
      const timeDifferenceInMinutes =
        timeDifferenceInMilliseconds / (1000 * 60);

      const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 8) === 0;
      const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

      let error = "";
      if (!isMultipleOf15Minutes) {
        error = `Time difference must be a multiple of 8 hours for ${label}`;
      } else if (!isAtLeast1Hour) {
        error = `Minimum time difference must be 1 day for ${label}`;
      }

      return error;
    }
    default: {
      // Handle invalid aggregation period
      return `Invalid aggregation period: ${aggregationPeriod}`;
    }
  }
};


const handleSubmit = async () => {
const sectionError = validateInput(sectionId, "Section");
const converterError = validateInput(converterGroupId, "Converter");
const meterError = validateInput(selectedMeterIds?.length, "Meter");
const paraError = validateInput(selectedValues, "Parameter");
const fromDateError = validateInput(fromDateString, "From Date");
const toDateError = validateToDateInput(
  toDateString,
  fromDateString,
  aggregationTime,
  "From Date"
);
const aggregationError = validateInput(aggregationTime, "Aggregation");

setSectionError(sectionError);
setConverterError(converterError);
setMeterError(meterError);
setParaError(paraError);
setFromDateError(fromDateError);
setToDateError(toDateError);
setAggregationError(aggregationError);

if (
  !sectionError &&
  !converterError &&
  !meterError &&
  !paraError &&
  !fromDateError &&
  !toDateError &&
  !aggregationError
) {
  onClose();

  const ids = selectedMeterIds?.map((id) => id).join(",");
  const para = selectedValues?.map((id) => id).join(",");
  console.log(selectedValues)

  const fromDate = new Date(fromDateString);
  const toDate = new Date(toDateString);

  const fromHours = fromDate.getUTCHours();
  const fromMinutes = fromDate.getUTCMinutes();
  const fromSeconds = fromDate.getUTCSeconds();

  const toHours = toDate.getUTCHours();
  const toMinutes = toDate.getUTCMinutes();
  const toSeconds = toDate.getUTCSeconds();

  // Set the UTC hours, minutes, and seconds
  fromDate.setUTCHours(fromHours);
  fromDate.setUTCMinutes(fromMinutes);
  fromDate.setUTCSeconds(fromSeconds);

  toDate.setUTCHours(toHours);
  toDate.setUTCMinutes(toMinutes);
  toDate.setUTCSeconds(toSeconds);

  const formattedFromDate = generatedISOFormatDateString(fromDate);
  const formattedToDate = generatedISOFormatDateString(toDate);

  try {
    const inputData = {
      SectionID: Number(sectionId) || 0,
      ConverterorGroupID: Number(converterGroupId) || 0,
      MeterIds: ids || ["0"],
      Parameters: para || ["0"],
      FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
      ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
    };

    setIsLoading(true); 
    getResponse(inputData)



    console.log('first data')
    console.log(data)
    console.log(aggeregationResData)

    const aggregationName = aggeregationResData.find(
      (aggregation) => aggregation.aggregationPeriodID === aggregationTime
    ).aggregationPeriodName;

    const period =
      aggregationName === "15Mins"
        ? "min"
        : aggregationName === "60Min Report"
          ? "min"
          : aggregationName === "24Hours Report"
            ? "day"
            : aggregationName === "Monthly Report"
              ? "month"
              : "min";

    const interval =
      aggregationName === "15Mins"
        ? 15
        : aggregationName === "60Min Report"
          ? 60
          : aggregationName === "24Hours Report"
            ? 1
            : aggregationName === "Monthly Report"
              ? 1
              : 480;

    const seriesData = groupDataByInterval(
      data,
      interval,
      period,
      fromDate
    );

    const input = seriesData?.chartArray;

    const inputArr = input;
    const dateArray = seriesData?.firstRecordCreatedONArray;
    console.log(dateArray)
    console.log(inputArr)


  } catch (err) {
    console.log(err);
  }finally {
    setIsLoading(false); 
  }
}
};

const handleTreeChange = (values) => {
  setSelectedValues(values);

  if (values.length>4) {
    console.log(values)
    setParameterLenght('Cannot select more than 4 values')
  }else{
    setParameterLenght('')
  }
  if (values) {
    setParaError("");
  }
};


useEffect(() => {
  if (loading || !data1 || !data2) return; 

  console.log(data1);
  console.log(data2);

  const myChart = echarts.init(chartRef.current);

  const option = {
    backgroundColor: isdarkMode ? '#2d3748' : '#fff',
    title: {
      text: `Comparative Report`,
      left: 'center',
      top: '5px',
      textStyle: {
        color: isdarkMode ? 'white' : 'black',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      confine: true, 
      position: function (point, params, dom, rect, size) {
        // `point` is the mouse position, `[x, y]`
        // `size` contains the size of the tooltip
        const [x, y] = point;
        const { contentSize, viewSize } = size; // Size of the tooltip and view
    
        let xPos = x + 10; // Add padding to the right
        let yPos = y + 10; // Add padding to the bottom
    
        // Prevent overflow on the right
        if (xPos + contentSize[0] > viewSize[0]) {
          xPos -= contentSize[0] + 20; // Move it left if it overflows
        }
    
        // Prevent overflow on the left
        if (xPos < 0) {
          xPos = 10; // Reset to a small margin on the left
        }
    
        // Prevent overflow at the bottom
        if (yPos + contentSize[1] > viewSize[1]) {
          yPos -= contentSize[1] + 20; // Move it up if it overflows
        }
    
        // Prevent overflow at the top
        if (yPos < 0) {
          yPos = 10; // Reset to a small margin at the top
        }
    
        return [xPos, yPos];
      },
    },
    
    legend: {
      bottom: '0px',
      textStyle: {
        color: isdarkMode ? 'white' : 'black',
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true,
    },
    toolbox: {
      show: true,
      orient: 'horizontal',
      left: 'right',
      top: 'top',
      
      feature: {
        myExport: {
          show: true,
          title: "Export to Excel",
          icon: "path://M5 0L15 10L5 20Z", // Custom arrow-like icon
          onclick: () => {
            exportToExcel(data2);
          },
        },
        mark: { show: true },
        magicType: { show: true, type: ['line', 'bar'] },
        saveAsImage: { show: true },
      },
      iconStyle: {
        borderColor: isdarkMode ? 'white' : 'black', // Change icon color based on theme
      },
      emphasis: {
        iconStyle: {
          borderColor: isdarkMode ? '#FFD700' : '#1E90FF', // Highlighted color on hover
        },
      },
    },
    xAxis: [
      {
        type: 'category',
        data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`),
        axisTick: { show: false },
        data: data1,
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',
          fontSize: '10',
          rotate: 90,
          fontWeight: 'bold',
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color: isdarkMode ? 'white' : 'black',
          fontSize: '10',
          fontWeight: 'bold',
        },
      },
    ],
    series: data2,
    dataZoom: [
      {
        type: 'inside', // Enables zooming via scroll or pinch
        start: 0,
        end: 100,
      },
    ],
  };

  myChart.setOption(option);

  const resizeHandler = () => myChart.resize();
  window.addEventListener('resize', resizeHandler);

  return () => {
    window.removeEventListener('resize', resizeHandler);
    myChart.dispose();
  };
}, [data1, data2, isdarkMode, loading]); 


console.log(data1)
console.log(data2)

console.log(loading)

const handleTimeRangeChange = (value) => {
  const now = dayjs(); // Current time using Day.js for formatting
  let fromTime;

  switch (value) {
    case "60min":
      fromTime = now.subtract(60, "minute");
      break;
    case "8hours":
      fromTime = now.subtract(8, "hour");
      break;
    case "7days":
      fromTime = now.subtract(7, "day");
      break;
    case "30days":
      fromTime = now.subtract(30, "day");
      break;
    case "90days":
      fromTime = now.subtract(90, "day");
      break;
    case "24hours":
      fromTime = now.subtract(1, "day");
      break;
    default:
      fromTime = null;
  }

  console.log("From:", fromTime);
  console.log("To:", now);
  // Format the dates into a string compatible with DatePicker
  const fromTimeString = fromTime ? fromTime.format("YYYY-MM-DD HH:mm:ss") : null;
  const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
  console.log("From:", fromTimeString);
  console.log("To:", toTimeString);
  // console.log(fromTime)
  // 2024-11-08 00:00:00
  // 2024-11-20 16:05:57
  setToDateObj(null);
  setFromDateObj(null);

  // Optionally, you can return these values or set them in state
  // return { fromTimeString, toTimeString };
  console.log(time)
  console.log(checkedValue)
  // if(checkedValue){
  //   setFromDateString(null)
  //   setToDateString(null)
  // }else{
    setFromDateString(fromTimeString);
    setToDateString(toTimeString);
  // }
  setFrom(fromTimeString)
  setTo(toTimeString)
};


useEffect(()=>{
  setFromDateString(null);
    setToDateString(null);
    setTime(false)
    setCheckedValue(null)
},[aggregationTime])

const exportToExcel = (data) => {
  
  console.log(data);
  console.log(shift);

  if (shift === '24hours') {

    const addOneDay = (dateString) => {
      // Parse the date string into a Date object
      const [day, month, year, time] = dateString.split(/[\/,]/);
      const fullDateString = `${year.trim()}-${month.trim()}-${day.trim()} ${time.trim()}`;
      const date = new Date(fullDateString);
  
      // Add one day
      date.setDate(date.getDate() + 1);
  
      // Format the new date into a readable string
      return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
      });
    };

    console.log(selectedValues.toString());

    // Define headers
    const headers = ["Meter", "Time", "Shift1", "Shift2", "Shift3", "Total Energy", "Parameter"];

    // Create rows for each device
    const rows = data.map((item) => {
      const fromDate = item.date[0];  // Use the first date as the 'From' date
      const toDate = item.date[2];  // Calculate the 'To' date as one day later
      // const toDate = addOneDay(fromDate);  // Calculate the 'To' date as one day later

      const timeRange = `From : ${fromDate} To : ${toDate}`;

      const totalEnergy = item.data.reduce((sum, value) => sum + (value || 0), 0);

      return [
        item.name, // Meter (Device Name)
        timeRange, // Time (From and To)
        item.data[0] || 0, // Shift1
        item.data[1] || 0, // Shift2
        item.data[2] || 0, // Shift3
        totalEnergy, // Total Energy (Sum of all shifts)
        selectedValues.toString(), // Parameter (Assuming a static value)
      ];
    });

    // Combine headers and rows
    const excelData = [headers, ...rows];

    // Create a new workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

    // Generate a filename with the current date and time in local timezone
    const now = new Date();
    const timestamp = now
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false, // Use 24-hour format
      })
      .replace(/[/,: ]/g, "-"); // Replace unwanted characters for a filename

    const filename = `Comparative_Report_${timestamp}.xlsx`;

    console.log("Generated Filename: ", filename);

    // Trigger a download
    XLSX.writeFile(workbook, filename);
  }
  else  {
    console.log(data);
    if (typeof XLSX === "undefined") {
      throw new Error("SheetJS (XLSX) library is required for this function.");
    }
  
    // Helper function to parse dates
    const parseDate = (dateString) => new Date(dateString);
  
    // Helper function to format dates
    const formatDate = (date) => {
      return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    };
  
    // Step 1: Calculate intervals dynamically based on the first two timestamps
    const firstMeter = data[0];
    const startTime = parseDate(firstMeter.date[0]);
    const secondTime = parseDate(firstMeter.date[1]);
    const endTime = parseDate(firstMeter.date[firstMeter.date.length - 1]);
  
    // Calculate the interval in minutes
    const intervalInMinutes = Math.round((secondTime - startTime) / (60 * 1000));
  
    const intervals = [];
    let currentTime = new Date(startTime.getTime()); // Start exactly from the first timestamp
  
    while (currentTime <= endTime) { // Ensure intervals include the last timestamp
      const nextTime = new Date(currentTime.getTime() + intervalInMinutes * 60 * 1000);
      intervals.push({
        from: formatDate(currentTime),
        to: formatDate(nextTime),
        startTime: new Date(currentTime), // Raw date for comparison
        endTime: new Date(nextTime), // Raw date for comparison
      });
      currentTime = nextTime;
    }
  
    // Step 2: Create headers for Excel
    const headers = ["From Date", "To Date", ...data.map((item) => item.name),"Parameter"];
  
    // Step 3: Populate rows with data for each interval
    const rows = [];
    rows.push(headers); // Add headers as the first row
  
    const totals = {}; // Store totals for each meter
    data.forEach((item) => (totals[item.name] = 0)); // Initialize totals
  
    intervals.forEach((interval) => {
      const row = [interval.from, interval.to]; // Add interval details
  
      data.forEach((item) => {
        // Find the first matching date for the interval
        const dateIndex = item.date.findIndex(
          (date) =>
            parseDate(date) >= interval.startTime && parseDate(date) < interval.endTime
        );
  
        // Include the first value for the first interval
        const value = dateIndex !== -1 ? item.data[dateIndex] : 0; // Default to 0 if no matching data
        row.push(value);
  
        // Update totals
        totals[item.name] += value;
      });
      row.push(selectedValues.toString());
      rows.push(row); // Add the interval row to the sheet
    });
  
    // Step 4: Add a total row
    const totalRow = ["Total", "", ...data.map((item) => totals[item.name] || 0)];
    rows.push(totalRow);
  
    // Step 5: Create Excel file using SheetJS
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    const worksheet = XLSX.utils.aoa_to_sheet(rows); // Convert rows to a worksheet
    XLSX.utils.book_append_sheet(workbook, worksheet, "Interval Report"); // Append worksheet to workbook
  
    // Step 6: Generate filename with timestamp
    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
    const filename = `Comparative_Report${timestamp}.xlsx`;
  
    // Step 7: Write the Excel file
    XLSX.writeFile(workbook, filename);
  };
  
};


const handleCheckboxChange = (checked, value) => {
  setCheckedValue(checked ? value : null);  
  setTime(!time);
  console.log(checked)
  console.log(value)

  if(checked){
    setShift(value)
    handleTimeRangeChange(value);
  }else{
    setFromDateString(null);
    setToDateString(null);
  }
  console.log('Checked value:', checked ? value : 'None');
};

const aggregationMap = {
  1: { value: "60min", label: "Last 60 Minutes" },
  2: { value: "8hours", label: "Last 8 Hours" },
  3: { value: "7days", label: "Last 7 Days" },
  4: { value: "30days", label: "Last 30 Days" },
  4: { value: "90days", label: "Last 90 Days" },
  5: { value: "24hours", label: "Last 24 Hours" },
};
console.log(checkedValue)
console.log(time)
console.log(data1)



return (
  <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
   
     <Card
          className={`p-5 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
          style={{ position: 'relative', overflow: 'hidden' }}
          bordered={false}
    >
        {
          data1.length ==0 && !loadings && !loading &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         }
          {(loading  || loadings) && ( 
      <>  
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
      

        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[650px]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>
    </Card>
    <CustomDrawer
      title="Close"
      showDrawer={showDrawer}
      open={open}
      onClose={onClose}
    >
      <div className="flex flex-col space-y-2">
        <CustomSelect
          label="Section:"
          options={getFlowSectionList}
          onSelect={handleChangeSection}
          valueKey="sectionID"
          nameKey="sectionName"
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {sectionError}
        </small>
        <CustomSelect
          label="Converter / Group:"
          options={
            sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
          }
          onSelect={handleChangeConverterGroup}
          
          valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
          nameKey={sectionId === 1 ? "sitename" : "department"}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {converterError}
        </small>
        <TreeSelectCustomWithSelectAll
          label="Meters:"
          data={
            sectionId === 1
              ? nsGetFlowConverterList
              : getFlowSteamGroupMeterList
          }
          idKey={sectionId === 1 ? "meterid" : "meterid"}
          valueKey={sectionId === 1 ? "meterid" : "meterid"}
          nameKey={sectionId === 1 ? "metername" : "metername"}
          selectedValues={selectedMeterIds}
          setSelectedValues={setSelectedMeterIds}
          onSelect={handleMeterChange}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {meterError}
        </small>
        <TreeSelectCustom 
          label="Parameters:"
          data={parameter}
          idKey="id"
          nameKey="name"
          valueKey="name"
          selectedValues={selectedValues}
          onSelect={handleTreeChange}
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {paraError}
          {/* {parameterLenght} */}
        </small>
        <CustomSelect
          label="Aggregation period:"
          options={aggeregationList}
          onSelect={handleChangeAggregation}
          valueKey="aggregationPeriodID"
          nameKey="aggregationPeriodName" 
        />
        <small className="text-red-500 font-bold ml-[150px]">
          {aggregationError}
        </small>
        <div className="mt-2 flex flex-col">
            {aggregationMap[aggregationTime] && (
              <div  className={`custom-checkbox ml-[130px] ${ isdarkMode ? 'dark-theme' : 'light-theme'} `}>
            <Checkbox 
            checked={checkedValue === aggregationMap[aggregationTime].value} 
            defaultChecked
            onChange={(e) =>
              handleCheckboxChange(e.target.checked, aggregationMap[aggregationTime].value)
            }
          >
            {/* <p className={`${isdarkMode ? 'text-white' : 'text-black'}`}> */}
            {aggregationMap[aggregationTime].label}  
            {/* </p> */}
          </Checkbox>
              </div>
          )}
          <small className="text-red-500 font-bold ml-[150px] w-full">
              {toDateError}
            </small>
        </div>

       
        { !time && !checkedValue? <>
           <div className="mt-2 flex">
          <label className="pr-3 w-32 text-left">From Date:</label>
          <DatePicker
            value={fromDateObj}
            onChange={onChangeFromDate}
            className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
            dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
            showTime={{ format: "HH:mm:ss" }}
            format="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <small className="text-red-500 font-bold ml-[150px]">
          {fromDateError}
        </small>
        <div className="mt-2 flex">
          <label className="pr-3 w-32 text-left">To Date:</label>
          <DatePicker
            value={toDateObj}
            onChange={onChangeToDate}
            className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
            dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
            showTime={{ format: "HH:mm:ss" }}
            format="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <small className="text-red-500 font-bold ml-[150px]">
          {toDateError} 
        </small>
        </>:''
        }
      </div>
      <div className="flex justify-center mt-4">
        <Button
          className="blue-btn"
          onClick={() => {
            handleSubmit();
          }}
        >
          Search
        </Button>
      </div>
    </CustomDrawer>
  </div>
);
};

export default AirComparativeReport;






